import {Context} from '@gongxigames/framework/core/fragments/BuilderX/types';
import {Component, ComponentProps} from './Component';
import {RichText as RichTextConstructor, RichTextOptions, RichTextTextStyle} from '@gongxigames/framework/core/fragments/display';

export type RichTextProps = ComponentProps & {
    /**
     * string id from [[LanguageService]] strings
     * or
     * any unique id if customText property is defined
     */
    localeTextID: string;
    /**
     *  style preset name from [[RichText.styles]]
     *  or
     *  style configs, described in scene *.tsx
     */
    style: string | Partial<RichTextTextStyle>;
    maxWidth?: number;
    maxHeight?: number;
    text?: string;

};

export class RichText extends Component<RichTextProps, RichTextConstructor> {

    public readonly jsxType: string = 'rich_text';
    public ignoreChildren = true;

    public getConstructor(): new () => any {
        return RichTextConstructor as any;
    }

    clone(): Component<ComponentProps> {
        return new RichText(this.props);
    }
    public getNewElement(context: Context): RichTextConstructor {
        return new RichTextConstructor({
            ... this.getOptions(context),
            resourceLoader: context.getLoader(),
            languageService: context.getLanguageService()
        });
    }

    public updateProps(context: Context, container: RichTextConstructor, element: RichTextConstructor): void {
        super.updateProps(context, container, element);
        container.updateText(this.getOptions(context));
    }

    private getOptions(context: Context): RichTextOptions {
        return {
            id: this.props.localeTextID,
            style: this.props.style,
            resolution: context.resolution,
            customText: this.props.text,
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight
        };
    }
}
